import React from 'react';
import { CampaignCard } from '@/components/card/campaign-card';
export const CampaignCardGrid = ({ data, canClone, onView, onDelete, onChangeStatus, isUpdatingStatus, isDeleting, dateFormat, }) => {
    return (<div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {data.map((campaign) => (<CampaignCard campaign={campaign} canClone={canClone} isUpdatingStatus={isUpdatingStatus} isDeleting={isDeleting} dateFormat={dateFormat} onView={onView} onDelete={onDelete} onChangeStatus={onChangeStatus} key={`campaign-${campaign.publicId}`}/>))}
        </div>);
};
CampaignCardGrid.displayName = 'CampaignCardGrid';
